<style scoped lang="less">
    .stepContainer-footer {
        .button {
            margin-top: 5px !important;
        }
        padding: 20px;
        display: flex;
        justify-content: space-between;
    }

    .table-sub-header {
        &.totals {
            text-align: right !important;
            padding-right: 75px;
        }
        text-align: center !important;
        font-size: 24px;
    }

    .expandedtr td:first-of-type {
        text-indent: 50px;
    }

    .invoiceData {
        .toggle {
            content: ' ';
            display: inline-block;

            border-top: 5px solid transparent;
            border-bottom: 5px solid transparent;
            border-left: 5px solid currentColor;

            vertical-align: middle;
            margin-right: .7rem;
            transform: translateY(-2px);

            transition: transform .2s ease-out;
        }
        .expanded .toggle {
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
        }
        .expanded .toggle {
            transform: rotate(90deg) translateX(-3px);
        }
        .expandable {
            cursor: pointer;
        }
        .vertical-spacer {
            height: 50px;
        }
        table {
            display: table;
            flex-shrink: 0;
            width: 100%;
            & > tr:first-of-type {
                border-top: 0;
                background-color: #D0D0D0;
            }
            tr.header-columns td {
                border-bottom: 1px solid #D0D0D0;
            }
            & > tr.data-row:first-of-type td {
                border-top: 0px;
            }
            & > tr > td {
                border-top: 1px solid #D0D0D0;
                padding-left: 15px;
                padding-right: 15px;
            }
            & > tr > td:last-of-type {
                text-align: right;
            }
            & > tr > th {
                padding-left: 15px;
                padding-right: 15px;
            }
            & > tr > th:last-of-type {
                text-align: right;
            }
            & > tr.expandedtr > td {
                border-top: 0px;
            }
            & > tr.expandedtr > td:first-of-type {
                text-indent: 50px;
            }
            th.groupfooter {
                border-top: 2px solid #D0D0D0;
                background-color: #D0D0D0;
                font-size: 18px;
            }
            th.groupheader {
                font-size: 18px;
                text-align: center !important;
            }
            input[type='text'] {
                height: 20px;
            }
            .addMiscRow {
                background-color: #eeeeee;
            }
        }
    }
</style>
<template>
    <div class="columns">
        <div class="column is-12">
            <div
                    v-if="!invoiceInfo"
                    class="spinner-loader"
            >
                <sync-loader/>
                <p>Loading ...</p>
            </div>
            <div
                    v-if="invoiceInfo"
                    class=""
            >
                <v-container fluid>
                    <v-row justify="space-around">
                        <img src="/images/dps.png" style="width:240px;height: auto;">
                    </v-row>
                    <v-row justify="space-around">
                        <v-col cols="8" md="4">
                            <v-card>
                                <v-card-title>Billed To</v-card-title>
                                <v-card-text>
                                    {{invoiceInfo.billTo.bill_to_name}}<br>
                                    {{invoiceInfo.billTo.bill_to_address1}}<br>
                                    <template v-if="invoiceInfo.billTo.bill_to_address2">
                                        {{invoiceInfo.billTo.bill_to_address2}}<br></template>
                                    {{invoiceInfo.billTo.bill_to_city}}, {{invoiceInfo.billTo.bill_to_state}}
                                    {{invoiceInfo.billTo.bill_to_zip}}
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col md="4" cols="8">
                            <v-card>
                                <v-card-title>Pay To</v-card-title>
                                <v-card-text>
                                    {{invoiceInfo.payTo.bill_to_name}}<br>
                                    {{invoiceInfo.payTo.bill_to_address1}}<br>
                                    <template v-if="invoiceInfo.payTo.bill_to_address2">
                                        {{invoiceInfo.payTo.bill_to_address2}}<br></template>
                                    {{invoiceInfo.payTo.bill_to_city}}, {{invoiceInfo.payTo.bill_to_state}}
                                    {{invoiceInfo.payTo.bill_to_zip}}
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row justify="space-around">
                        <v-col cols="12" md="10">
                            <v-divider></v-divider>
                        </v-col>
                    </v-row>
                    <v-row justify="space-around">
                        <v-col cols="12" md="10">
                            <v-simple-table>
                                <thead>
                                <tr>
                                    <th colspan="3" class="table-sub-header">Game related charges</th>
                                </tr>
                                <tr>
                                    <th>Date</th>
                                    <th>Description</th>
                                    <th>Amount</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-for="date in Object.keys(invoiceInfo.data.dates)">
                                    <template v-if="ignoreFields.indexOf(date) < 0">
                                        <tr>
                                            <td>{{date}}</td>
                                            <td>{{invoiceInfo.data.dates[date].description}}</td>
                                            <td>{{invoiceInfo.data.dates[date].invoiceAmount | toCurrency}}</td>
                                        </tr>
                                        <template v-for="venueid in Object.keys(invoiceInfo.data.dates[date])">
                                            <template v-if="ignoreFields.indexOf(venueid) < 0">
                                                <template
                                                        v-for="(session, index) in invoiceInfo.data.dates[date][venueid]">
                                                    <tr class="expandedtr">
                                                        <td>{{ session.name }} {{ session.session }}</td>
                                                        <td>{{ session.description }}</td>
                                                        <td>{{session.invoiceAmount | toCurrency}}</td>
                                                    </tr>
                                                </template>
                                            </template>
                                        </template>
                                    </template>
                                </template>
                                </tbody>
                                <thead>
                                <tr>
                                    <th colspan="3" class="table-sub-header">Miscellaneous charges</th>
                                </tr>
                                <tr>
                                    <th>Date</th>
                                    <th>Description</th>
                                    <th>Amount</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-for="row in invoiceInfo.data.miscellaneous">
                                    <template v-if="ignoreFields.indexOf(row) < 0">
                                        <tr>
                                            <td>{{row.date}}</td>
                                            <td>{{row.description}}</td>
                                            <td>{{row.invoiceAmount | toCurrency}}</td>
                                        </tr>
                                    </template>
                                </template>
                                </tbody>
                                <thead>
                                <tr>
                                    <th colspan="3" class="table-sub-header totals" align="right">
                                        <v-row justify="end">
                                            <v-col cols="12" md="4">
                                                <v-card>
                                                    <v-card-title>Totals</v-card-title>
                                                    <v-card-text>
                                                        <v-simple-table>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Sub-total</td>
                                                                    <td>{{invoiceInfo.amount_total | toCurrency}}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Payments Made:</td>
                                                                    <td>{{invoiceInfo.amount_paid | toCurrency | amountPaid}}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Sub-total</td>
                                                                    <td>{{getGrandTotal | toCurrency}}</td>
                                                                </tr>
                                                             </tbody>
                                                        </v-simple-table>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </th>
                                </tr>
                                </thead>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'InvoiceView',
        filters: {},
        components: {},
        props: {
            token: {
                type: String,
            },
            user: {
                type: Object,
            }
        },
        filters: {
            toCurrency(val) {
                return "$" + parseFloat(val).toFixed(2)
            },
            amountPaid(val) {
                return val > 0 ? "-" + val : val
            }
        },
        data() {
            return {
                invoiceInfo: null,
                ignoreFields: ['invoiceAmount', 'expanded', 'description'],
            }
        },
        watch: {},
        mounted: function () {
            this.getInvoiceData()
        },
        computed: {
            getGrandTotal() {
                let grandTotal = this.invoiceInfo.amount_total - this.invoiceInfo.amount_paid
                if (grandTotal < 0) {
                    return "(" + grandTotal + ")"
                }
                return grandTotal
            }
        },
        methods: {
            getInvoiceData() {
                let url = `admin/franchise/getinvoice`
                let data = {
                    type: 'invoice',
                    token: this.token,
                    guid: this.$route.params.guid
                }
                this.$axios({
                    method: 'POST',
                    url,
                    headers: {
                        Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    data
                })
                    .then((res) => {
                        this.invoiceInfo = res.data
                        this.invoiceInfo.data = JSON.parse(this.invoiceInfo.data)
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
        }
    }
</script>
